import { EnumerateCreditsResponseModel } from '../../api/data-contracts';

export * from './types';

// your mapping functions for payment should be here
export const getMinimalCreditPayment = ({ credits }: EnumerateCreditsResponseModel): number =>
  credits
    ?.map(({ monthPrice, codes }) => codes === null && monthPrice)
    .filter(Boolean)
    .sort((a, b) => +a - +b)[0] || 0;
